import { useEffect, useMemo } from 'react';
import { useLocales } from 'src/locales';
import SvgColor from 'src/components/svg-color';
import { useNavigate } from 'react-router';
import { useProfileContext } from 'src/components/profile/context';

// ----------------------------------------------------------------------
const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  clipboard: icon('ic_clipboard'),
  incident: icon('ic-incident'),
  arrows: icon('ic-change-req'),
  uppdownArrows: icon('ic-priority'),
  team: icon('ic-Response'),
  calendar2: icon('ic-Quarterly'),
  Survey: icon('ic-Survey'),
  Analysis: icon('ic-Analysis'),
  Inventory: icon('ix-Inventory'),
  Budget: icon('ic-Budget'),
  Learning: icon('ic-Learning'),
};
// ----------------------------------------------------------------------
export function useSubmittalsNavData() {
  const { t } = useLocales();

  const { userProfile, userPermissions: permissions } = useProfileContext();
  const userPermissions = permissions.filter((perm) => perm !== 'submittals.dashboard');
  const navigate = useNavigate();

  const hasnestedPermission = (keyword) => userPermissions.some((perm) => perm.startsWith(keyword));

  const hasDashboardPermission = hasnestedPermission('submittals.dashboard');

  // useEffect(() => {
  //   if (userProfile && hasDashboardPermission === false) {
  //     navigate('/dashboard/adminuser', { replace: true });
  //   }
  // }, []);

  const filteredItems = (items) => items.filter((item) => item.visible);

  const data = useMemo(
    () => [
      {
        subheader: t(''),
        items: filteredItems([
          {
            title: t('Dashboard'),
            path: '/submittals',
            icon: ICONS.clipboard,
            visible: true,
          },
          {
            title: t('Submittals'),
            path: '/submittals/submittals',
            icon: ICONS.incident,
            visible: hasnestedPermission('submittals'),
          },
          {
            title: t('Submittals Package'),
            path: '/submittals/packages',
            icon: ICONS.arrows,
            visible: hasnestedPermission('submittal_packages'),
          },
          {
            title: t('Transmittal'),
            path: '/submittals/transmittal',
            icon: ICONS.chat,
            visible: hasnestedPermission('transmittals'),
          },
          {
            title: t('Submittals Library'),
            path: '/submittals/library',
            icon: ICONS.Inventory,
            // visible: hasnestedPermission('submittal_library'),
            visible: true,
          },
        ]),
      },
    ],
    [t, userPermissions]
  );

  return data;
}
